module.exports = __webpack_public_path__ + "static/media/logo.bf76014d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 481
// module chunks = 0